import { urlBuilder } from '@/connectors/endpoints'
import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { IEmployee } from '@/types/employees'

const deleteEmployee = (employeeId: number, moid: number, endPoint: string) => {
  return new AxiosRequestBuilder<IEmployee>({
    url: urlBuilder(endPoint, String(employeeId), String(moid)),
    method: 'delete'
  }).exec()
}

export default deleteEmployee
